<template>
  <div>
      <l-map id="map" v-if="termsAccepted" ref="leafletMap" :style="{ height: mapHeight }" :zoom="zoom" :center="center" :key="filterKey">
        <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
        <v-marker-cluster>
          <l-marker :lat-lng="[e.lat, e.lng]" v-for="e in events">
            <l-popup>
              <h4>{{ e.title }}</h4>
              <span class="text-meta club-name"><b>Verein/Träger:</b> {{ e.club }}</span>
              <div class="form-actions">
                <div class="form-actions__right">
                  <EventDetailsLink :event="e"/>
                </div>
              </div>
            </l-popup>
          </l-marker>
        </v-marker-cluster>
      </l-map>

      <div id="events_map" v-else :style="{ height: mapHeight }">
        <div id="events_map-inner">
          <p>
            Diese Webseite verwendet den externen Kartendienst
            <a href="https://www.openstreetmap.de/" target="_blank">OpenStreetMap</a>.
          </p>
          <p>
            <a href="https://www.openstreetmap.org/copyright" target="_blank">Lizenzbedingungen öffnen</a>
          </p>
          <p class="my-0">
            <a class="button" id="map_preload_click" @click="confirmMapStatus($event)" href="#">Bedingungen akzeptieren</a>
          </p>
        </div>
      </div>
  </div>
</template>

<script>
import EventDetailsLink from './event_details_link.vue'

export default {
  components: {
    EventDetailsLink
  },
  props: {
    events: {
      type: Array,
      default: () => { return [] }
    },
    filterKey: {
      type: Number,
      required: true,
    },
  },
  data(){
    return {
      termsAccepted: localStorage.getItem("mapOSM") === 'true',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      zoom: 12,
      center: [52.51811127849241, 13.377773518816989],
      zoomPadding: [30, 30],
      mapHeight: '400px',
    }
  },
  mounted() {
    this.fitMapBounds()
  },
  computed: {
    mapBounds() {
      if (this.events.length === 0) {
        return null
      }
      return L.latLngBounds(this.events.map(e => [e.lat, e.lng]))
    }
  },
  watch: {
    mapBounds(newBounds) {
      this.fitMapBounds(newBounds)
    }
  },
  methods: {
    fitMapBounds(bounds = this.mapBounds){
      this.$nextTick(() => {
        const map = this.$refs.leafletMap?.mapObject

        if (map && bounds && bounds.isValid()) {
          map.fitBounds(bounds, { padding: this.zoomPadding })
        }
      })
    },
    confirmMapStatus(e){
      e.preventDefault()
      localStorage.setItem("mapOSM", true)
      this.termsAccepted = true
      this.fitMapBounds()
    },
  }

}
</script>

<style>
.vue2leaflet-map { height: 300px; margin-bottom: 5px; z-index: 1;}
</style>
